const BASE_URL = 'https://norma.education-services.ru/api';

export default BASE_URL;
